import {configureStore} from "@reduxjs/toolkit" 
import checkedReducer from "./checkedSlice"; 
import sessionReducer from "./sessionSlice";

export const store = configureStore({
    reducer: { 
        checked: checkedReducer,
        session: sessionReducer
    },
});

export default store;

